<template>
  <div>
    <slot name="intro" />
    <ul v-if="items && items.length > 0">
      <li v-for="(item, index) in items" :key="index">
        <a v-if="item"
           :href="item.url"
           target="_blank">
          <v-icon :color="$finColors.primaryDark"
                  class="mr-1"
                  small>
            mdi-download
          </v-icon>
          {{ item[name] }} - Version {{ item.version }} (Stand: {{ item.createdAt | date }})
        </a>
      </li>
    </ul>
    <p v-else>Keine Dokumente verfügbar</p>
    <slot name="more-infos"/>
  </div>
</template>

<script>

export default {
  name: "FinDocumentDownloads",
  components: {},
  props: {
    /** All documents */
    items: {
      type: Array,
      required: true
    },
    /**
     * Name of the field that should be displayed as document name
     */
    name: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>

<style lang="scss" scoped>

a {
  color: $fin-color-primary-dark !important;
  text-decoration: none;
}

</style>
